/* istanbul ignore file */
export default {
  noteText: {
    type: 'string',
    required: true,
    minSize: 30,
    maxSize: 65000,
  },
};
